import { React, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Button from "@mui/material/Button";
import DoneIcon from "@mui/icons-material/Done";
import MDBadge from "components/MDBadge";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Dropdown } from "semantic-ui-react";
import { ToastContainer, toast } from "react-toastify";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import colors from "assets/theme/base/colors";
import nodata from "assets/images/nodata.png";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

function Degree() {
  // Variable Declarations
  const [program_name, setProgramName] = useState("");
  const [description, setDescription] = useState("");
  const [department_id, setDepartmentId] = useState("");
  const [degree_level_id, setDegreeLevelId] = useState("");
  const [campus_id, setCampusId] = useState("");
  const [duration, setDuration] = useState("");
  const [duration_type, setDurationType] = useState("");
  const [program_short_code, setProgramShortCode] = useState("");
  const [credit_hours, setCreditHours] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("");
  const [degrees, setDegrees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [campuses, setCampuses] = useState([]);
  const [degreeLevels, setDegreeLevels] = useState([]);
  const [showAddDegreeModal, setShowAddDegreeModal] = useState(false);
  const [showDeleteDegreeModal, setShowDeleteDegreeModal] = useState(false);
  const [showUpdateDegreeModal, setShowUpdateDegreeModal] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [formErrors, setFormErrors] = useState({
    program_name,
    department_id,
    degree_level_id,
    campus_id,
    duration,
    duration_type,
    program_short_code,
    credit_hours,
    category,
    status,
  });

  const callErrors = (
    PROGRAMNAME,
    DEPARTMENT,
    DEGREELEVEL,
    CAMPUS,
    DURATION,
    DURATIONTYPE,
    PROGRAMCODE,
    CREDITHOURS,
    CATEGORY,
    STATUS
  ) => {
    const errors = {};
    if (PROGRAMNAME === "") {
      errors.program_name = " * Program name is Required";
    }
    if (DEPARTMENT === "") {
      errors.department_id = " * Please Select the Department";
    }
    if (DEGREELEVEL === "") {
      errors.degree_level_id = " * Please Select the Degree Level.";
    }
    if (CAMPUS === "") {
      errors.campus_id = " * Please Select the Campus";
    }
    if (DURATION === "") {
      errors.duration = " * Please Enter the Duration";
    }
    if (DURATIONTYPE === "") {
      errors.duration_type = " * Please Select the Duration Type";
    }
    if (PROGRAMCODE === "") {
      errors.program_short_code = " * Please Enter the Program Code";
    }
    if (CREDITHOURS === "") {
      errors.credit_hours = " * Please Enter the Credit Hours";
    }
    if (CATEGORY === "") {
      errors.category = " * Please Select the Category";
    }
    if (STATUS === "") {
      errors.status = " * Please Select the Status";
    }

    setFormErrors(errors);
  };

  // Dialog Settings
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [opens, setOpens] = useState(false);
  const [currentAppId, setCurrentAppId] = useState(null);

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget);
    setOpens(true);
    setCurrentAppId(appId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpens(false);
    setCurrentAppId(null);
  };

  //  Session Storage Calls
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getDegrees();
    } else {
      let filteredDegrees = degrees.filter((deg) => {
        const programNameMatch =
          deg.program_name &&
          deg.program_name.toLowerCase().includes(searchTerm);
        const descriptionMatch =
          deg.description && deg.description.toLowerCase().includes(searchTerm);
        const departmentNameMatch =
          deg.department_name &&
          deg.department_name.toLowerCase().includes(searchTerm);
        const degreeLevelNameMatch =
          deg.degree_level_name &&
          deg.degree_level_name.toLowerCase().includes(searchTerm);
        const campusNameMatch =
          deg.campus_name && deg.campus_name.toLowerCase().includes(searchTerm);
        const durationTypeMatch =
          deg.duration_type &&
          deg.duration_type.toLowerCase().includes(searchTerm);
        const programShortCodeMatch =
          deg.program_short_code &&
          deg.program_short_code.toLowerCase().includes(searchTerm);
        const CategoryMatch =
          deg.category && deg.category.toLowerCase().includes(searchTerm);
        const StatusMatch =
          deg.status && deg.status.toLowerCase().includes(searchTerm);

        return (
          programNameMatch ||
          descriptionMatch ||
          departmentNameMatch ||
          degreeLevelNameMatch ||
          campusNameMatch ||
          durationTypeMatch ||
          programShortCodeMatch ||
          CategoryMatch ||
          StatusMatch
        );
      });
      setDegrees(filteredDegrees);
    }
  };

  // GET Api Calls
  const getDegrees = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(`${BASE_URL}/degree/get_degrees`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setDegrees(data.degrees);
      })
      .catch((error) => console.log(error));
  };
  const getCampuses = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(`${BASE_URL}/campus/get_campuses`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setCampuses(data.campuses);
      })
      .catch((error) => console.log(error));
  };
  const getDepartments = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(`${BASE_URL}/department/get_departments`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setDepartments(data.departments);
      })
      .catch((error) => console.log(error));
  };
  const getDegreeLevels = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(`${BASE_URL}/degree/get_degree_levels`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setDegreeLevels(data.degree_levels);
      })
      .catch((error) => console.log(error));
  };

  // Add Functions
  const showDegreeAddModal = () => {
    setShowAddDegreeModal(true);
  };
  const handleOkAddDegreeModal = () => {
    if (
      program_name &&
      department_id &&
      degree_level_id &&
      campus_id &&
      duration &&
      duration_type &&
      program_short_code &&
      credit_hours &&
      category &&
      status
    ) {
      addDegree();
      setShowAddDegreeModal(false);
    } else {
      callErrors(
        program_name,
        department_id,
        degree_level_id,
        campus_id,
        duration,
        duration_type,
        program_short_code,
        credit_hours,
        category,
        status
      );
    }
  };
  const handleCancelAddDegreeModal = () => {
    setShowAddDegreeModal(false);
    setProgramName("");
    setDescription("");
    setDepartmentId("");
    setDegreeLevelId("");
    setCampusId("");
    setDuration("");
    setProgramShortCode("");
    setCreditHours("");
    setCategory("");
    setStatus("");
    setFormErrors({
      program_name: "",
      department_id: "",
      degree_level_id: "",
      campus_id: "",
      duration: "",
      duration_type: "",
      program_short_code: "",
      credit_hours: "",
      category: "",
      status: "",
    });
  };
  const addDegree = () => {
    let data = {
      program_name,
      description,
      department_id,
      degree_level_id,
      campus_id,
      duration,
      duration_type,
      program_short_code,
      credit_hours,
      category,
      status,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    fetch(`${BASE_URL}/degree/add_degree`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getDegrees();
        toast.success("Degree Added Successfully");
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setProgramName("");
        setDescription("");
        setDepartmentId("");
        setDegreeLevelId("");
        setCampusId("");
        setDuration("");
        setProgramShortCode("");
        setCreditHours("");
        setCategory("");
        setStatus("");
        setFormErrors({
          program_name: "",
          department_id: "",
          degree_level_id: "",
          campus_id: "",
          duration: "",
          duration_type: "",
          program_short_code: "",
          credit_hours: "",
          category: "",
          status: "",
        });
      });
  };

  // Delete Functions
  const showDegreeDeleteModal = () => {
    setShowDeleteDegreeModal(true);
  };
  const handleOkDeleteDegreeModal = () => {
    deleteDegree();
    setShowDeleteDegreeModal(false);
  };
  const handleCancelDeleteDegreeModal = () => {
    setShowDeleteDegreeModal(false);
  };
  const deleteDegree = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(
      `${BASE_URL}/degree/delete_degree/${currentAppId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        getDegrees();
        toast.success("Degree Deleted Successfully");
      })
      .catch((error) => console.log(error));
  };

  const [selectedDegree, setSelectedDegree] = useState(null);
  // Update Functions
  const showDegreeUpdateModal = () => {
    const degreeToUpdate = degrees.find((degree) => degree.id === currentAppId);
    setSelectedDegree(degreeToUpdate);
    setShowUpdateDegreeModal(true);
  };

  const handleOkUpdateDegreeModal = () => {
    if (
      selectedDegree.id &&
      selectedDegree.program_name &&
      selectedDegree.description &&
      selectedDegree.department_id &&
      selectedDegree.campus_id &&
      selectedDegree.degree_level_id &&
      selectedDegree.duration &&
      selectedDegree.duration_type &&
      selectedDegree.program_short_code &&
      selectedDegree.credit_hours &&
      selectedDegree.category &&
      selectedDegree.status
    ) {
      updateDegree();
      setShowUpdateDegreeModal(false);
    } else {
      callErrors(
        selectedDegree.program_name,
        selectedDegree.description,
        selectedDegree.department_id,
        selectedDegree.campus_id,
        selectedDegree.degree_level_id,
        selectedDegree.duration,
        selectedDegree.duration_type,
        selectedDegree.program_short_code,
        selectedDegree.credit_hours,
        selectedDegree.category,
        selectedDegree.status
      );
    }
  };

  const handleCancelUpdateDegreeModal = () => {
    setShowUpdateDegreeModal(false);
    setProgramName("");
    setDescription("");
    setDepartmentId("");
    setDegreeLevelId("");
    setCampusId("");
    setDuration("");
    setProgramShortCode("");
    setCreditHours("");
    setCategory("");
    setStatus("");
    setFormErrors({
      program_name: "",
      department_id: "",
      degree_level_id: "",
      campus_id: "",
      duration: "",
      duration_type: "",
      program_short_code: "",
      credit_hours: "",
      category: "",
      status: "",
    });
  };

  const updateDegree = () => {
    // Check if a degree is selected
    if (selectedDegree) {
      const data = {
        id: selectedDegree.id,
        program_name: selectedDegree.program_name,
        description: selectedDegree.description,
        department_id: selectedDegree.department_id,
        campus_id: selectedDegree.campus_id,
        degree_level_id: selectedDegree.degree_level_id,
        duration: selectedDegree.duration,
        duration_type: selectedDegree.duration_type,
        program_short_code: selectedDegree.program_short_code,
        credit_hours: selectedDegree.credit_hours,
        category: selectedDegree.category,
        status: selectedDegree.status,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify(data),
      };
      fetch(`${BASE_URL}/degree/update_degree`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          getDegrees();
          toast.success("Degree Updated Successfully");
        })
        .catch((error) => console.log(error))
        .finally(() => {
          // Reset the selectedDegree and input fields
          setSelectedDegree(null);
          setProgramName("");
          setDescription("");
          setDepartmentId("");
          setDegreeLevelId("");
          setCampusId("");
          setDuration("");
          setDurationType("");
          setProgramShortCode("");
          setCreditHours("");
          setCategory("");
          setStatus("");
          setFormErrors({
            program_name: "",
            department_id: "",
            degree_level_id: "",
            campus_id: "",
            duration: "",
            duration_type: "",
            program_short_code: "",
            credit_hours: "",
            category: "",
            status: "",
          });
          setShowUpdateDegreeModal(false);
        });
    }
  };
  const handleCopyLink = () => {
    navigator.clipboard.writeText(
      `${window.location.origin}/apply-degree/${currentAppId}/${organization_id}`
    );
    toast.success("Copied to Clipboard");
  };
  const handleFocus = (e) => {
    const { name } = e.target;

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  // Rows & Columns Injection
  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Program Name", accessor: "program_name", align: "left" },
    { Header: "Department", accessor: "department", align: "left" },
    { Header: "Degree Level", accessor: "degree_level", align: "center" },
    { Header: "Campus", accessor: "campus", align: "center" },
    { Header: "Duration", accessor: "duration", align: "center" },
    { Header: "Category", accessor: "category", align: "center" },
    { Header: "Program Code", accessor: "program_code", align: "center" },
    { Header: "Credit Hours", accessor: "credit_hours", align: "center", },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows =
    degrees.length > 0
      ? degrees.map((degree, index) => ({
          serial: index + 1,
          program_name: degree.program_name,
          department: degree.department_name,
          degree_level: degree.degree_level_name,
          campus: degree.campus_name,
          duration: degree.duration + " " + degree.duration_type,
          category: degree.category,
          program_code: degree.program_short_code,
          credit_hours: degree.credit_hours,
          status:
            degree.status == 1 ? (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="Active"
                  color="success"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ) : (
              <MDBox ml={-1}>
                <MDBadge
                  badgeContent="Inactive"
                  color="error"
                  variant="gradient"
                  size="sm"
                />
              </MDBox>
            ),
          actions: (
            <>
              <div>
                <IconButton
                  aria-label="more"
                  id={`long-button-${index}`}
                  aria-controls={opens ? "long-menu" : undefined}
                  aria-expanded={opens ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={(event) => handleClick(event, degree.id)}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  anchorEl={anchorEl}
                  open={opens}
                  onClose={handleClose}
                >
                  <MenuItem onClick={showDegreeDeleteModal}>
                    <DeleteIcon style={{ marginRight: "15px", color: "red" }} />{" "}
                    Delete
                  </MenuItem>
                  <MenuItem onClick={showDegreeUpdateModal}>
                    <EditIcon style={{ marginRight: "15px", color: "green" }} />{" "}
                    Edit
                  </MenuItem>
                  <MenuItem onClick={handleCopyLink}>
                    <ContentCopyIcon
                      style={{ marginRight: "15px", color: "indigo" }}
                    />{" "}
                    Copy Link
                  </MenuItem>
                </Menu>
              </div>
            </>
          ),
        }))
      : [
          {
            serial: null,
            program_name: null,
            description: null,
            department: null,
            degree_level: null,
            campus: null,
            duration: null,
            category: null,
            program_code: null,
            credit_hours: null,
            status: null,
            actions: null,
          },
        ];

  // Initial Renderings
  useEffect(() => {
    getDegrees();
    getDepartments();
    getDegreeLevels();
    getCampuses();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card
              className="mt-5"
              sx={{ boxShadow: "none", border: "1px solid #DADADAEE", borderRadius: "5px" }}
            >
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper
                      component="form"
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "333px",
                        border: "1px solid #8C8C8C",
                        boxShadow: "none",
                      }}
                    >
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon
                       sx={{ color: "gray", width: "22px", height: "22px" }}
                      />
                    </Paper>
                  </Stack>
                  <Button
                    variant="filled"
                    endIcon={<AddIcon  sx={{width: "22px", height: "22px",  marginLeft: "22px", }} />}
                    onClick={showDegreeAddModal}
                    style={{
                      color: "white",
                      background: info.main,
                      fontWeight: 500,
                      height: '40px',
                      width: "120px",
                      fontSize: "16px",
                    }}
                  >
                    Add
                  </Button>
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {degrees && degrees.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nodata}
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog
        fullScreen={fullScreen}
        open={showAddDegreeModal}
        onClose={handleCancelAddDegreeModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Add Degree"}</DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Program Name</label>
                <input
                  name="program_name"
                  type="text"
                  value={program_name}
                  onChange={(e) => setProgramName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Program Name"
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.program_name}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Description</label>
                <input
                  name="description"
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Description"
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.description}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Category</label>
                <Dropdown
                  placeholder="Select Category"
                  fluid
                  selection
                  value={category}
                  onChange={(e, { value }) => setCategory(value)}
                  onFocus={handleFocus}
                  options={[
                    { key: 1, text: "National", value: "National" },
                    { key: 2, text: "International", value: "International" },
                  ]}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.category}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Department</label>
                <Dropdown
                  placeholder="Select Department"
                  fluid
                  selection
                  value={department_id}
                  onChange={(e, { value }) => setDepartmentId(value)}
                  onFocus={handleFocus}
                  options={departments.map((dept) => ({
                    key: dept.id,
                    text: dept.name,
                    value: dept.id,
                  }))}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.department_id}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Degree Level</label>
                <Dropdown
                  placeholder="Select Degree Level"
                  fluid
                  selection
                  value={degree_level_id}
                  onChange={(e, { value }) => setDegreeLevelId(value)}
                  onFocus={handleFocus}
                  options={degreeLevels.map((deg) => ({
                    key: deg.id,
                    text: deg.name,
                    value: deg.id,
                  }))}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.degree_level_id}</div>
            </div>
            <div className="col-md-12">
              <div className="form-outline mt-3">
                <label>Campus</label>
                <Dropdown
                  placeholder="Select Campus"
                  fluid
                  selection
                  value={campus_id}
                  onChange={(e, { value }) => setCampusId(value)}
                  onFocus={handleFocus}
                  options={campuses.map((camp) => ({
                    key: camp.id,
                    text: camp.name,
                    value: camp.id,
                  }))}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.campus_id}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Duration</label>
                <input
                  name="duration"
                  type="number"
                  value={duration}
                  onChange={(e) => {
                    if (e.target.value > 0) {
                      setDuration(e.target.value);
                    } else {
                      setDuration(0);
                    }
                  }}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Duration"
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.duration}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Duration Type</label>
                <Dropdown
                  placeholder="Select Duration Type"
                  fluid
                  selection
                  value={duration_type}
                  onChange={(e, { value }) => setDurationType(value)}
                  onFocus={handleFocus}
                  options={[
                    { key: 1, text: "Years", value: "Years" },
                    { key: 2, text: "Months", value: "Months" },
                    { key: 3, text: "Weeks", value: "Weeks" },
                    { key: 4, text: "Days", value: "Days" },
                  ]}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.duration_type}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Program Short Code</label>
                <input
                  name="program_short_code"
                  type="text"
                  value={program_short_code}
                  onChange={(e) => setProgramShortCode(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Program Short Code"
                />
              </div>
              <div style={{ color: "red" }}>
                {formErrors.program_short_code}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Credit Hours</label>
                <input
                  name="credit_hours"
                  type="text"
                  value={credit_hours}
                  onChange={(e) => setCreditHours(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Credit Hours"
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.credit_hours}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3 mb-5">
                <label>Status</label>
                <Dropdown
                  placeholder="Select Status"
                  fluid
                  selection
                  value={status}
                  onChange={(e, { value }) => setStatus(value)}
                  onFocus={handleFocus}
                  options={[
                    { key: 1, text: "Active", value: "1" },
                    { key: 2, text: "Inactive", value: "0" },
                  ]}
                />
              </div>
              <div style={{ color: "red" }}>{formErrors.status}</div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelAddDegreeModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkAddDegreeModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={showDeleteDegreeModal}
        onClose={handleCancelDeleteDegreeModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Delete Degree"}
        </DialogTitle>
        <DialogContent>
          Are you sure you want to delete this Degree?
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelDeleteDegreeModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkDeleteDegreeModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={showUpdateDegreeModal}
        onClose={handleCancelUpdateDegreeModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Update Degree"}
        </DialogTitle>
        <DialogContent>
          {selectedDegree && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Program Name</label>
                    <input
                      name="program_name"
                      type="text"
                      value={selectedDegree.program_name}
                      onChange={
                        (e) =>
                          setSelectedDegree({
                            ...selectedDegree,
                            program_name: e.target.value,
                          })
                        // (e) => setProgramName(e.target.value)
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Program Name"
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.program_name}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Description</label>
                    <input
                      name="name"
                      type="text"
                      value={selectedDegree.description}
                      onChange={
                        (e) =>
                          setSelectedDegree({
                            ...selectedDegree,
                            description: e.target.value,
                          })
                        //   (e) => setDescription(e.target.value)
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Description"
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.description}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Category</label>
                    <Dropdown
                      placeholder="Select Category"
                      fluid
                      selection
                      value={selectedDegree.category}
                      onChange={(e, { value }) =>
                        setSelectedDegree({
                          ...selectedDegree,
                          category: value,
                        })
                      }
                      onFocus={handleFocus}
                      options={[
                        { key: 1, text: "National", value: "National" },
                        {
                          key: 2,
                          text: "International",
                          value: "International",
                        },
                      ]}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.category}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Department</label>
                    <Dropdown
                      placeholder="Select Department"
                      fluid
                      selection
                      value={selectedDegree.department_id}
                      onChange={(e, { value }) =>
                        setSelectedDegree({
                          ...selectedDegree,
                          department_id: value,
                        })
                      }
                      onFocus={handleFocus}
                      options={departments.map((dept) => ({
                        key: dept.id,
                        text: dept.name,
                        value: dept.id,
                      }))}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.department_id}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Degree Level</label>
                    <Dropdown
                      placeholder="Select Degree Level"
                      fluid
                      selection
                      value={selectedDegree.degree_level_id}
                      onChange={(e, { value }) =>
                        setSelectedDegree({
                          ...selectedDegree,
                          degree_level_id: value,
                        })
                      }
                      onFocus={handleFocus}
                      options={degreeLevels.map((deg) => ({
                        key: deg.id,
                        text: deg.name,
                        value: deg.id,
                      }))}
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.degree_level_id}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-outline mt-3">
                    <label>Campus</label>
                    <Dropdown
                      placeholder="Select Campus"
                      fluid
                      selection
                      value={selectedDegree.campus_id}
                      onChange={(e, { value }) =>
                        setSelectedDegree({
                          ...selectedDegree,
                          campus_id: value,
                        })
                      }
                      onFocus={handleFocus}
                      options={campuses.map((camp) => ({
                        key: camp.id,
                        text: camp.name,
                        value: camp.id,
                      }))}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.campus_id}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Duration</label>
                    <input
                      name="duration"
                      type="text"
                      value={selectedDegree.duration}
                      onChange={
                        (e) =>
                          setSelectedDegree({
                            ...selectedDegree,
                            duration: e.target.value,
                          })
                        // (e) => setDuration(e.target.value)
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Duration"
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.duration}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Duration Type</label>
                    <Dropdown
                      placeholder="Select Duration Type"
                      fluid
                      selection
                      value={selectedDegree.duration_type}
                      onChange={(e, { value }) =>
                        setSelectedDegree({
                          ...selectedDegree,
                          duration_type: value,
                        })
                      }
                      onFocus={handleFocus}
                      options={[
                        { key: 1, text: "Years", value: "Years" },
                        { key: 2, text: "Months", value: "Months" },
                        { key: 3, text: "Weeks", value: "Weeks" },
                        { key: 3, text: "Days", value: "Days" },
                      ]}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.duration_type}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Program Short Code</label>
                    <input
                      name="program_short_code"
                      type="text"
                      value={selectedDegree.program_short_code}
                      onChange={
                        (e) =>
                          setSelectedDegree({
                            ...selectedDegree,
                            program_short_code: e.target.value,
                          })
                        // (e) => setProgramShortCode(e.target.value)
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Program Short Code"
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {formErrors.program_short_code}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Credit Hours</label>
                    <input
                      name="credit_hours"
                      type="text"
                      value={selectedDegree.credit_hours}
                      onChange={
                        (e) =>
                          setSelectedDegree({
                            ...selectedDegree,
                            credit_hours: e.target.value,
                          })
                        // (e) => setCreditHours(e.target.value)
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Credit Hours"
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.credit_hours}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3 mb-5">
                    <label>Status</label>
                    <Dropdown
                      placeholder="Select Status"
                      fluid
                      selection
                      value={selectedDegree.status}
                      onChange={(e, { value }) =>
                        setSelectedDegree({
                          ...selectedDegree,
                          status: value,
                        })
                      }
                      onFocus={handleFocus}
                      options={[
                        { key: 1, text: "Active", value: "1" },
                        { key: 2, text: "Inactive", value: "0" },
                      ]}
                    />
                  </div>
                  <div style={{ color: "red" }}>{formErrors.status}</div>
                </div>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelUpdateDegreeModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkUpdateDegreeModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Degree;
